export default [
  // Groupes d'utilisateurs
  {
    path: 'accounts/groups',
    name: 'Groups',
    component: () => import('./views/Groups/Groups.vue'),
  },
  {
    path: 'accounts/groups/new',
    name: 'AddGroup',
    component: () => import('./views/Groups/AddGroup.vue'),
  },
  {
    path: 'accounts/groups/:id',
    name: 'GroupDetail',
    component: () => import('./views/Groups/GroupDetail.vue'),
  },
  // Groupes d'organisations
  {
    path: 'accounts/spheres',
    name: 'Spheres',
    component: () => import('./views/Spheres/Spheres.vue'),
  },
  {
    path: 'accounts/spheres/new',
    name: 'AddSphere',
    component: () => import('./views/Spheres/AddSphere.vue'),
  },
  {
    path: 'accounts/spheres/:id',
    name: 'SphereDetail',
    component: () => import('./views/Spheres/SphereDetail.vue'),
  }
];
